export default {
  // Gift type: 1=Physical, 2=Virtual
  giftType: {
    1: 'Physical Gift',
    2: 'Virtual Gift',
  },
  // Spec type: 1=Single, 2=Multi
  specType: {
    1: 'Single Spec',
    2: 'Multi Spec',
  },
  // Publish status: 0=Offline, 1=Online
  publishStatus: {
    0: 'Offline',
    1: 'Online',
  },
  // Order status: 0=Pending, 1=Exchanged, 2=Shipped, 3=Completed, 4=Cancelled, 5=Failed
  orderStatus: {
    0: 'Pending',
    1: 'Exchanged',
    2: 'Shipped',
    3: 'Completed',
    4: 'Cancelled',
    5: 'Failed',
  },
  // Shipping status: 1=Pending, 2=Shipped, 3=Completed
  shippingStatus: {
    1: 'Pending',
    2: 'Shipped',
    3: 'Completed',
  },
  // Account status: 0=Disabled, 1=Active
  accountStatus: {
    0: 'Disabled',
    1: 'Active',
  },
  // Account type: 1=Main Account, 2=Sub Account
  accountType: {
    1: 'Main Account',
    2: 'Sub Account',
  },
  // Encryption protocol
  encryption: {
    ssl: 'SSL',
    tls: 'TLS',
    none: 'None',
  },
  // Material type
  materialType: {
    image: 'Image',
    video: 'Video',
  },
  // Scan count
  scanCount: {
    first: 'First',
    repeated: 'Repeated',
  },
  // Default template toggle
  isDefault: {
    on: 'On',
    off: 'Off',
  },
};
